import {Card, ListGroup, Nav} from "react-bootstrap";
import React from "react";
import {NavLink} from "react-router-dom";
import {Milestone, Route, Trophy, GalleryVerticalEnd, GalleryVertical} from 'lucide-react';
import IconTip from "./IconTip";

const EventSummaryCard = (props) => {
    return (
        <Card>
            <Card.Header className="text-center">
                <Nav><NavLink to={"/bike/events/" + props?.id}>{props?.eventName}</NavLink></Nav>
            </Card.Header>
            <Card.Body>
                <ListGroup horizontal>
                    {props?.type === "counter-commute" && (
                        <ListGroup.Item>
                            <IconTip tip="Number of commutes">
                                <Route size={20} className="me-2 text-primary"/>
                            </IconTip>
                            <span className="fw-bold">{props?.rides}</span>
                        </ListGroup.Item>
                    )}
                    {(props?.type === "sum-commute" || props?.type === "sum-total") && (
                        <ListGroup.Item>
                            <IconTip tip="Total distance">
                                <Milestone size={20} className="me-2 text-success"/>
                            </IconTip>
                            {parseFloat(props?.distance).toFixed(1)}km
                        </ListGroup.Item>
                    )}
                    <ListGroup.Item>
                        <IconTip tip="Your position">
                            <Trophy size={20} className="text-info"/>
                        </IconTip>
                        <span className="fw-bold">{props?.position ?? "?"}/{props?.total}</span>
                    </ListGroup.Item>
                    {props?.type === "counter-commute" && (
                        <ListGroup.Item>
                            <IconTip tip="Gap to the person ahead">
                                <GalleryVerticalEnd size={20} className="text-success me-1"/>
                            </IconTip>
                            <span className="fw-bold">{props?.gapAhead != null ? `+${props.gapAhead}` : "?"}</span>
                        </ListGroup.Item>
                    )}
                    {(props?.type === "sum-commute" || props?.type === "sum-total") && (
                        <ListGroup.Item>
                            <IconTip tip="Gap to the person ahead">
                                <GalleryVerticalEnd size={20} className="me-2 text-success"/>
                            </IconTip>
                            {props?.gapAhead != null ? `+${parseFloat(props.gapAhead / 1000).toFixed(1) / 1.0}km` : "?"}
                        </ListGroup.Item>
                    )}
                    {props?.type === "counter-commute" && (
                        <ListGroup.Item>
                            <IconTip tip="Gap to the person behind">
                                <GalleryVertical size={20} className="text-danger me-1"/>
                            </IconTip>
                            <span className="text-danger fw-bold">{props?.gapBehind != null ? `-${props.gapBehind}` : "?"}</span>
                        </ListGroup.Item>
                    )}
                    {(props?.type === "sum-commute" || props?.type === "sum-total") && (
                        <ListGroup.Item>
                            <IconTip tip="Gap to the person behind">
                                <GalleryVertical size={20} className="text-danger me-1"/>
                            </IconTip>
                            <span className="text-danger fw-bold">{props?.gapBehind != null ? `-${parseFloat(props.gapBehind / 1000).toFixed(1) / 1.0}km` : "?"}</span>
                        </ListGroup.Item>
                    )}
                </ListGroup>
            </Card.Body>
            <Card.Footer>{props?.startDate}&#10230;{props?.endDate}</Card.Footer>
        </Card>
    )
}

export default EventSummaryCard;